import SelfEmployment from "./SelfEmployment"
import Employment from "./Employment"
import SocialSecurity from "./SocialSecurity"
import Pension from "./Pension"
import Rental from "./Rental"
import Alimony from "./Alimony"
import ChildSupport from "./ChildSupport"
const cardTypes = {
  SelfEmployment,
  Employment,
  SocialSecurity,
  Pension,
  Rental,
  Alimony,
  ChildSupport
}
export default cardTypes
